import type {
  CreateSessionInput,
  ListSessionsResponse,
  SessionMutationResponse,
  SessionType,
  UpdateSessionInput,
} from "@mvk/shared";
import { apiRequest } from "./client";

export const adminSessionsApi = {
  list(eventId: string) {
    return apiRequest<ListSessionsResponse>(`/events/${eventId}/sessions`, {
      audience: "admin",
    });
  },

  create(eventId: string, body: CreateSessionInput) {
    return apiRequest<SessionMutationResponse>(`/events/${eventId}/sessions`, {
      method: "POST",
      body,
      audience: "admin",
    });
  },

  update(eventId: string, sessionId: string, body: UpdateSessionInput) {
    return apiRequest<SessionMutationResponse>(
      `/events/${eventId}/sessions/${sessionId}`,
      {
        method: "PATCH",
        body,
        audience: "admin",
      },
    );
  },

  remove(eventId: string, sessionId: string) {
    return apiRequest<{ ok: boolean }>(`/events/${eventId}/sessions/${sessionId}`, {
      method: "DELETE",
      audience: "admin",
    });
  },
};

export type { SessionType, CreateSessionInput, UpdateSessionInput };
